import { apiClient } from "../apiClient";
import { IToaNha } from "../../model/respone/category/IToaNha";
export const TOA_NHA_API = "toa-nha";
export const toaNhaApi = {
  SelectAll: () => apiClient.get(`${TOA_NHA_API}`),
  Insert: (payload: IToaNha) => apiClient.post(`${TOA_NHA_API}`, payload),
  Update: (payload: IToaNha) => apiClient.put(`${TOA_NHA_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${TOA_NHA_API}/${id}`),
};
